import { Layout, LayoutContainer, Page } from "@fdoh/health-ui-react";
import { DataTable, Select2 } from "@fdoh/health-react";
import { useEffect, useRef, useState } from "react";
import {Link, useHistory,  useLocation } from "react-router-dom";
import useData from "../../hooks/useData";
import useClient from "../../hooks/useInspectionClient";
import { Row } from "@fdoh/health-react";



export type CountyEmailData = {
  key: string;
  value: string;
};

const Columns = [
  {
      Header: "County Name",
      accessor: (row: CountyEmailData) => row.key,
      
  },
  {
      Header: "County Email",
      Cell: ({ row }: { row: { original: CountyEmailData } }) => (
        <a href={`mailto:${row.original.value}`}>{row.original.value}</a>
      ),
      //accessor: (row: CountyEmailData) => row.value, 
  },
]

export const SupportRequestPage = () => {
  const { search } = useLocation();
  const client = useClient();
  const searchParams = new URLSearchParams(search);
    const applicationId = JSON.parse(searchParams.get("applicationId") || '{}');
    const inspectionId = JSON.parse(searchParams.get("inspectionId") || '{}');
    const [countyEmailData, setCountyEmailData] = useState<CountyEmailData[]>([]);

    let countyEmails= useData<CountyEmailData[]>('county/GetEmailByCountyId' );
    let Recentlyopened = countyEmails?.filter(x => x.key == "1");
    
    return (
      <Page.Container>
         <div>

<div className="card-body text-center">
 
  <p>Please be aware that user, technical, and programmatic support will be available during regular business hours, generally Monday through Friday, 8 am to 5 pm (eastern time).  All issues and requests will be handled as soon as possible during these business hours.</p>
  <p>For access and technical difficulties with the application, please contact:
  <a href="mailto:DCEH_TechSupport@flhealth.gov"> DCEH_TechSupport@flhealth.gov</a></p>

  
  <p>For questions, comments, or issues with the inspection form and content, please contact: 
<a href="mailto:OSTDS_Feedback@FloridaDEP.gov"> OSTDS_Feedback@FloridaDEP.gov</a></p>

 
  <div>

  </div>
</div>
</div>
      <LayoutContainer>
                  <div className="county-grid">
                  <p>
For permitting and inspection questions, contact your local county health department using the following directory.
</p>
                    <Row className="mt-4">
                  <DataTable
                      name="Countyemaillist"
                      columns={Columns}
                      data={countyEmails!=undefined?countyEmails:[]}
                      title="County Health Department contacts"
                      //pagination ={true}
                      globalFilter
                      striped
                      vcenter
                       />
                       </Row>
    </div>
          </LayoutContainer>
  </Page.Container>
    ); <div>
    
  </div>;
};

export default SupportRequestPage;